import type { ProjectId } from "features/shared/model/types";

import { withScenarioQuery } from "features/shared/lib/technical-config-tab/api/withScenarioQuery";

const url = `${process.env.REACT_APP_ENERGY_DASHBOARD_API_URL}/api/technicaltab`;

export const catalog = (catalogSegment: string, activeOnly = true) =>
  `${url}/${catalogSegment}?activeOnly=${activeOnly}`;

export const groupDetail = (projectId: ProjectId, userDefinedType: string, groupSegment: string, scenario?: string) =>
  withScenarioQuery(`${url}/projects/${projectId}/${groupSegment}/${encodeURIComponent(userDefinedType)}`, scenario);

export const groups = (projectId: ProjectId, groupSegment: string, scenario?: string) =>
  withScenarioQuery(`${url}/projects/${projectId}/${groupSegment}`, scenario);
